/**
 * Centralized application URLs for consistency and maintainability.
 */
export const URLS = {
  TERMS: 'https://docufyai.com/terms-of-use',
  PRIVACY_POLICY: 'https://docufyai.com/privacy-policy',
} as const;

/** SessionStorage key for post-signup terms acceptance (shown before onboarding). */
export const TERMS_ACCEPTED_STORAGE_KEY = 'terms_accepted';

/**
 * SessionStorage bridge: email/password sign-up captures marketing opt-in before /accept-terms.
 * Cleared after terms are saved so AcceptTerms can pre-fill if the terms API omits the field.
 */
export const SIGNUP_MARKETING_EMAILS_OPT_IN_SESSION_KEY = 'signup_marketing_emails_opt_in';
